import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class HeaderTogglePopup extends MainClass {
	// Element selectors
	private readonly SELECTORS = {
		toggleButton: '.raise-popup-toggle-icon',
		parentNavs: '.raise-parent-nav',
		childNavs: '.raise-popup-menu ul[class="menu"] > li.menu-item-has-children',
		popupMenu: '.raise-popup-menu',
		overlay: '.raise-popup-bg-overlay',
		subNavOverlay: '.js-sub-nav-overlay',
		childNavClone: '.raise-child-nav-clone',
	};

	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	private init(): void {
		this.setupChildNavs();
		this.setupMenuToggle();
		this.setupParentNavs();
	}

	private setupChildNavs(): void {
		const childNavs = Array.from( this.selector.querySelectorAll( this.SELECTORS.childNavs ) ) as HTMLElement[];

		if ( ! childNavs.length ) return;

		childNavs.forEach( nav => {
			// Create cloned navigation for mobile view
			const cloneNode = nav.cloneNode( true ) as HTMLElement;
			const cloneNodeWrapper = document.createElement( 'ul' );
			cloneNodeWrapper.classList.add( 'raise-child-nav-clone' );
			cloneNodeWrapper.appendChild( cloneNode );

			// Get parent element and add the clone
			const parentEle = nav.closest( '.raise-popup-menu-content' ) as HTMLElement;
			if ( ! parentEle ) return;

			const subNavOverlay = parentEle.querySelector( this.SELECTORS.subNavOverlay ) as HTMLElement;
			parentEle.appendChild( cloneNodeWrapper );

			// Set up click handlers
			const backToggle = cloneNode.querySelector( 'a' ) as HTMLElement;

			// Toggle submenu visibility on click
			nav.addEventListener( 'click', e => {
				e.preventDefault();
				cloneNodeWrapper.classList.toggle( 'active' );
				subNavOverlay?.classList.toggle( 'active' );
			} );

			// Back button functionality
			backToggle?.addEventListener( 'click', e => {
				e.preventDefault();
				cloneNodeWrapper.classList.remove( 'active' );
				subNavOverlay?.classList.remove( 'active' );
			} );
		} );
	}

	private setupMenuToggle(): void {
		const buttonToggle = this.selector.querySelector( this.SELECTORS.toggleButton ) as HTMLElement;
		if ( ! buttonToggle ) return;

		buttonToggle.addEventListener( 'click', () => {
			const spanList = Array.from( buttonToggle.querySelectorAll( 'span' ) ) as HTMLElement[];
			const popupMenu = this.selector.querySelector( this.SELECTORS.popupMenu ) as HTMLElement;
			const overlayEle = this.selector.querySelector( this.SELECTORS.overlay ) as HTMLElement;

			// Toggle button appearance
			spanList?.[ 0 ]?.classList?.toggle( 'active' );
			spanList?.[ 1 ]?.classList?.toggle( 'hidden' );
			spanList?.[ 2 ]?.classList?.toggle( 'active' );

			// Toggle menu visibility
			popupMenu?.classList.toggle( 'active' );
			overlayEle?.classList.toggle( 'active' );

			// Toggle body scroll
			document.querySelector( 'body' )?.classList.toggle( 'overflow-hidden' );
			document.querySelector( 'body' )?.classList.toggle( 'fixed' );

			// Reset submenu state when closing main menu
			if ( popupMenu && ! popupMenu.classList.contains( 'active' ) ) {
				this.resetSubmenuState();
			}
		} );
	}

	private resetSubmenuState(): void {
		const raiseChildNavClone = this.selector.querySelector( this.SELECTORS.childNavClone ) as HTMLElement;
		const subNavOverlay = this.selector.querySelector( this.SELECTORS.subNavOverlay ) as HTMLElement;

		raiseChildNavClone?.classList.remove( 'active' );
		subNavOverlay?.classList.remove( 'active' );
	}

	private setupParentNavs(): void {
		const parentNavs = Array.from( this.selector.querySelectorAll( this.SELECTORS.parentNavs ) ) as HTMLElement[];

		if ( ! parentNavs.length ) return;

		parentNavs.forEach( nav => {
			nav.addEventListener( 'click', () => {
				const childNavs = Array.from( nav.querySelectorAll( '.raise-child-nav' ) ) as HTMLElement[];
				const dropdownIcon = nav.querySelector( '.dropdown-icon' ) as HTMLElement;
				dropdownIcon?.classList?.toggle( 'active' );
				childNavs?.forEach( childNav => {
					childNav.classList.toggle( 'active' );
				} );
			} );
		} );
	}
}

export default HeaderTogglePopup;
